let worker = null;
const listeners = [];

export function initSharedWorker() {
  if (!worker) {
    console.log("🧠 Initializing shared worker...");
    if(typeof SharedWorker !== "undefined"){
      console.log("SharedWorker is supported");
      try {
        worker = new SharedWorker(`/sharedWorker.js`);
      } catch (err) {
        console.log("Error in initializing", err)
        worker = new SharedWorker(`${process.env.PUBLIC_URL}/sharedWorker.js`);
      }
      console.log("Shared worker Initialized")
      worker.port.start();
      worker.port.onmessage = (event) => {
        const data = event.data;
        console.log("📩 Message received in worker");
  
        if (data.type === "WSState") {
          listeners.forEach((cb) => cb({ type: "WSState", data }));
        }
  
        if (["scan_result_raw", "user_joined", "message", "user_left"].includes(data.type)) {
          listeners.forEach((cb) => cb(data))
        }
      };
    }
  }
}

export function connectSocket(token, url) {
  if (worker) {
    console.log("🔗 Connecting socket with token, url:", token, url);
    worker.port.postMessage({ type: "connect", payload: { token, url } });
  }
}

export function disconnectSocket() {
  if (worker) {
    console.log("🚫 Disconnecting socket...");
    worker.port.postMessage({ type: "disconnect" });
  }
}

export function sendMessage(message) {
  if (worker) {
    worker.port.postMessage({ type: "sendMessage", payload: message });
  }
}

export function sendJoinRoom(payload) {

  if (worker) {
    worker.port.postMessage({ type: "join_room", payload });
  }
}

export function sendPingSignal() {
  if (worker) {
    worker.port.postMessage({ type: "ping" });
  }
}

export function registerCallbackForSocketEvent(callback) {
  listeners.push(callback);
}
